// extracted by mini-css-extract-plugin
module.exports = {"cartItemWidgetImage":"CartItemWidget_cartItemWidgetImage__TrZIY","cartItemWidgetImageInner":"CartItemWidget_cartItemWidgetImageInner__ksznY"};